export enum CarbonOperationType {
  TRANSFER_WITHOUT_FINANCIAL = "TRANSFER_WITHOUT_FINANCIAL",
  WITHDRAW = "WITHDRAW",
  DEPOSIT = "DEPOSIT"
}
